import React from 'react';

import { Container, Box } from '@mui/system';
import { Typography } from '@mui/material';

//block groups
import BaseTable from '../../../../../blockGroups/table/BaseTable/BaseTable.blockgroup.jsx';

const purchaseOrderDetailsColumnConfigs = [
    {
        name: "sku",
        title: "SKU",
        objectFieldsToDisplay: ["equipment.sku"],
        objectFieldsDelimeter: "",
        useNestedObject: true
    },
    {
        name: "name",
        title: "Name",
        objectFieldsToDisplay: ["equipment.name"],
        objectFieldsDelimeter: "",
        useNestedObject: true
    },
    {
        name: "description",
        title: "Description",
        objectFieldsToDisplay: ["equipment.description"],
        objectFieldsDelimeter: "",
        useNestedObject: true
    },
    {
        name: "ordered",
        title: "Ordered",
        objectFieldsToDisplay: ["quantity"],
        objectFieldsDelimeter: "",
        useNestedObject: false,
        headerAlign: 'left',
        align: 'left',
        type: 'number'
    },
    {
        name: "received",
        title: "Received",
        objectFieldsToDisplay: ["quantityReceived"], 
        objectFieldsDelimeter: "",
        useNestedObject: false,
        headerAlign: 'left',
        align: 'left',
        type: 'number'
    },
    
]
    
const PurchaseOrderItemDetailsTable = ({ data = {equipmentPurchaseOrder: { orderItems:[]} }, error, loading }) => {
    // Use the column configurations and the raw data to create columns and rows for the table

    return (<Container maxWidth={false} disableGutters sx={{ marginTop: 8, marginBottom: 8}}>
        <Typography variant='h4'>Equipment</Typography>
            <Box sx={{ height: 500, width: "100%", marginTop: 2}}>
                <BaseTable 
                    rawData={data.equipmentPurchaseOrder.orderItems}
                    columnConfigs={purchaseOrderDetailsColumnConfigs}
                    loading={loading}
                />
            </Box>
    </Container>
    )
}
export default PurchaseOrderItemDetailsTable;